// @flow
import styled from 'styled-components';
import { Field, ErrorMessage } from 'formik';

export const StyledValidatedInput = styled.div`
  position: relative;
  margin-bottom: 20px;
`;

export const StyledInput = styled(Field)`
  display: block;
  width: 100%;
  height: 35px;
  padding: 10px 15px;
  border: 1px solid #ECECEC;
  border-radius: 2px;
  background-color: white;
  line-height: 35px;
  font-size: 14px;
  margin-bottom: 0 !important
`;

export const StyledErrorMessage = styled(ErrorMessage)`
  color: red;
  position: absolute;
  top: 35px;
  font-size: 14px;
`;

export const StyledSelect = styled(Field)`
  display: block;
  width: 100%;
  height: 35px;
  padding: 0 15px;
  border: 1px solid #ECECEC;
  border-radius: 2px;
  background-color: white;
  line-height: 35px;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 20px;
`;
